import { Box } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AllCoreBenifits from './Pages/AllCoreBenifits/AllCoreBenifits';
import Home from './Pages/Home/Home';
import HowItWorks from './Pages/HowItWorks/HowItWorks';
import Footer from './Pages/Shared/Footer/Footer';
import Navigation from './Pages/Shared/Navigation/Navigation';
import UseCase from './Pages/UseCase/UseCase';
import Entreprise from './Pages/Entreprise/Entreprise';
import OurTeam from './Pages/OurTeam/OurTeam';
import UseCaseDetails from './Pages/UseCase/UseCaseDetails';
import EcosystemDetails from './Pages/EcosystemDetails/EcosystemDetails';
import NotFound from './Pages/NotFound/NotFound';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Box sx={{ mx: { sm: 3, md: 6, lg: 8, xl: 28 } }}>
          <Navigation />
        </Box>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/works" element={<HowItWorks />} />
          <Route exact path="/cases" element={<UseCase />} />
          <Route exact path="/cases/:id" element={<UseCaseDetails />} />
          <Route exact path="/ecosystem/:id" element={<EcosystemDetails />} />
          <Route exact path="/core_benifits" element={<AllCoreBenifits />} />
          <Route exact path="/entreprise" element={<Entreprise />} />
          <Route exact path="/team" element={<OurTeam />} />
          <Route exact path="/not_found" element={<NotFound />} />
          <Route exact path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
